import { useQuery } from '@tanstack/react-query';
import { Cursor } from 'utils/apiClient/services/datev/types';
import { useApiClient } from 'utils/apiClient';

/* eslint-disable import/prefer-default-export */
export const useDatevLogs = (cursor: Cursor, enabled: boolean) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['datev', 'logs', cursor],
    queryFn: () => apiClient.Datev.fetchLogs(cursor),
    enabled,
    refetchOnWindowFocus: false,
  });
};
